module.exports = __webpack_public_path__ + "img/c8.6c1e8ab1.png";